import { makeStyles } from "@material-ui/core/styles";

export const LotDetailsContainerStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.secondary.light
  }
}));
